import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormGroupDirective } from '@angular/forms';
import { ValidationService } from 'src/app/core/services/validation.service';
import { isValiddateNumber } from 'src/app/core/directives/country-flag-phone/country-flag-phone.directive';
import { AppService } from 'src/app/core/services/app.service';
import { API } from '../../../../core/constants';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  registerForm: FormGroup;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  deviceData: Subscription;
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  performerInfoSubscr: Subscription;
  channelName: any;
  clientDetails:any;

  constructor(private formBuilder: FormBuilder,
    private appService: AppService,
    private toastr: ToastrService,
    private commonSubscribeService: CommanSubscribeService,
    private router: Router,
    private activatedRouter: ActivatedRoute
  ) { }
  deviceType = ''
  ngOnInit() {
    this.clientDetails = environment.clientDetails;
    this.deviceType = this.commonSubscribeService.deviceType;
    this.deviceData = this.commonSubscribeService.getAppType().subscribe(response => {
      this.deviceType = response;
    })
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    //get performer info
    //console.log(this.commonSubscribeService)
    let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    //console.log(perfomerInfoData)
    if (perfomerInfoData && Object.keys(perfomerInfoData).length != 0) {
      perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
    }
    this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      perfomerInfoData = response;
      this.channelName = perfomerInfoData?.data?.Data?.[0]?.channel_name || null;
      //console.log("HERE: ",this.channelName,perfomerInfoData)
    })
    this.registerForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ["", [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
      phone: ['', [Validators.required, isValiddateNumber.isvalidNumber(false)]],
      message: ['', Validators.required],
      organization_name: [''],
    });
    if (this.activatedRouter.snapshot.queryParams.email) {
      this.registerForm.patchValue({
        email: this.activatedRouter.snapshot.queryParams.email
      });
    }

  }
  onSubmit() {
    console.log("Org: ", "Heelolo")
    if (this.registerForm.valid) {
      console.log("Comes here")
      let url = API.CONTACT_US;
      let inputData = this.registerForm.value;
      inputData['type'] = this.deviceType == 'browser' ? "fan" : "fan_hybrid";
      this.appService.postRequest(url, inputData).subscribe(result => {
        if (result.status == 0) {
          this.toastr.success("Submitted successfully");
          setTimeout(() =>
            this.formGroupDirective.resetForm(), 0);
          if (this.userInfo && this.userInfo.id)
            this.router.navigateByUrl('/userhome');
          else
            this.router.navigateByUrl('/');
        }
      }, error => {
        console.log(error);
      })
    }
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
  }
}
